export default "__VITE_ASSET__d7qcW$pb__"